import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-parts',
    imports: [
        RouterOutlet
    ],
    templateUrl: './parts.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './parts.component.scss'
})
export class PartsComponent {
}
